'use client';

import { FC, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { Workspace } from 'hotdesk_typescript';
import { MyListing } from '@/hotdesk-ui/services/listing.service';
import CarouselSection from '@/hotdesk-ui/components/shared/CarouselSection';
import styles from './InactiveWorkspaceView.module.scss';
export interface InactiveWorkspaceViewProps {
  workspace: Workspace;
  similarWorkspaces: MyListing[];
}
const InactiveWorkspaceView: FC<InactiveWorkspaceViewProps> = ({
  workspace,
  similarWorkspaces
}) => {
  const t = useTranslations('workspace-details');
  const router = useRouter();
  const [countdown, setCountdown] = useState(10);
  useEffect(() => {
    if (similarWorkspaces.length === 0) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            handleExploreMore();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, []);
  const handleExploreMore = () => {
    router.push('/workspaces');
  };

  // Filter similar workspaces (limit to 10)
  const filteredSimilarWorkspaces = similarWorkspaces.slice(0, 10);
  return <div className={styles.page} data-sentry-component="InactiveWorkspaceView" data-sentry-source-file="InactiveWorkspaceView.tsx">
            <div className={styles.container}>
                {/* Sad Character Icon */}
                <div className={styles.iconWrapper}>
                    <img src="/assets/icons/inactive-workspace.svg" alt="inactive-workspace" />
                </div>

                {/* Main Content */}
                <div className={styles.content}>
                    <h1 className={styles.title}>
                        {t('workspace_currently_inactive')}
                    </h1>
                    <h2 className={styles.subtitle}>
                        {t('workspace_notified_message')}
                    </h2>

                    <p className={styles.description}>
                        {t('explore_available_workspaces')}
                    </p>

                </div>

                {/* Similar Workspaces Section */}
                {filteredSimilarWorkspaces.length > 0 ? <div className={styles.similarSection}>
                        <CarouselSection title="" listings={filteredSimilarWorkspaces as any} variant="workspace" showBookNow />
                    </div> : <p className={styles.redirectMessage}>
                        {t('redirecting_message')}
                        <span className={styles.countdown}>{countdown}</span>
                        {t('redirecting_seconds')}
                    </p>}
                {/* Explore Button */}
                <button type="button" className={styles.exploreButton} onClick={handleExploreMore}>
                    {t('explore_more')}
                </button>
            </div>
        </div>;
};
export default InactiveWorkspaceView;